import { useState } from "react";
import { NavLink } from "@/components/NavLink";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="container flex h-16 items-center justify-between px-4 md:px-6">
        <NavLink to="/" className="flex items-center space-x-2">
          <span className="text-xl font-bold text-primary">Leaf Rush Marketing</span>
        </NavLink>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6 text-sm font-medium">
          <NavLink
            to="/websites"
            className="text-foreground/70 transition-colors hover:text-foreground"
            activeClassName="text-foreground font-semibold"
          >
            Website Design
          </NavLink>
          <NavLink
            to="/growth-add-ons"
            className="text-foreground/70 transition-colors hover:text-foreground"
            activeClassName="text-foreground font-semibold"
          >
            Growth Add-Ons
          </NavLink>
          <NavLink
            to="/resources"
            className="text-foreground/70 transition-colors hover:text-foreground"
            activeClassName="text-foreground font-semibold"
          >
            Resources
          </NavLink>
          <NavLink
            to="/blog"
            className="text-foreground/70 transition-colors hover:text-foreground"
            activeClassName="text-foreground font-semibold"
          >
            Blog
          </NavLink>
          <NavLink
            to="/about"
            className="text-foreground/70 transition-colors hover:text-foreground"
            activeClassName="text-foreground font-semibold"
          >
            About
          </NavLink>
          <NavLink to="/contact">
            <Button size="sm">Contact</Button>
          </NavLink>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {mobileMenuOpen && (
        <div className="md:hidden border-t">
          <nav className="flex flex-col space-y-4 p-4">
            <NavLink
              to="/websites"
              className="text-foreground/70 transition-colors hover:text-foreground"
              activeClassName="text-foreground font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Website Design
            </NavLink>
            <NavLink
              to="/growth-add-ons"
              className="text-foreground/70 transition-colors hover:text-foreground"
              activeClassName="text-foreground font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Growth Add-Ons
            </NavLink>
            <NavLink
              to="/resources"
              className="text-foreground/70 transition-colors hover:text-foreground"
              activeClassName="text-foreground font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Resources
            </NavLink>
            <NavLink
              to="/blog"
              className="text-foreground/70 transition-colors hover:text-foreground"
              activeClassName="text-foreground font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              Blog
            </NavLink>
            <NavLink
              to="/about"
              className="text-foreground/70 transition-colors hover:text-foreground"
              activeClassName="text-foreground font-semibold"
              onClick={() => setMobileMenuOpen(false)}
            >
              About
            </NavLink>
            <NavLink to="/contact" onClick={() => setMobileMenuOpen(false)}>
              <Button className="w-full">Contact</Button>
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
};
